/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Footer_DocsInputs */

const en_landing_footer_docs = /** @type {(inputs: Landing_Footer_DocsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Docs`)
};

const id_landing_footer_docs = /** @type {(inputs: Landing_Footer_DocsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dokumentasi`)
};

/**
* | output |
* | --- |
* | "Docs" |
*
* @param {Landing_Footer_DocsInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const landing_footer_docs = /** @type {((inputs?: Landing_Footer_DocsInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Footer_DocsInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_landing_footer_docs(inputs)
	return en_landing_footer_docs(inputs)
});